'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { map } from 'rxjs/operators/map';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import { switchMap } from 'rxjs/operators/switchMap';
import { FETCHED_SPECIFIC_LISTS } from '../actions/ActionTypes';
import { receiveSpecificLists, requestedSpecificListsFailed, requestSpecificLists } from '../actions/ListsActions';
export default ((action$, _, {
  ListsClient
}) => action$.ofType(FETCHED_SPECIFIC_LISTS).pipe(switchMap(({
  payload: {
    listIds
  }
}) => ListsClient.fetchSpecificLists(listIds).pipe(map(receiveSpecificLists), catchError(error => of(requestedSpecificListsFailed(error))), startWith(requestSpecificLists())))));